<template>
  <base-card :loading="pending">
    <template v-slot:body-top>
      <base-card-title>Our Live Co-funding Opportunities</base-card-title>
    </template>
    <template v-if="investments && investments.length">
      <div v-for="(investment, key) in investments" :key="key" class="portfolio">
        <div class="row align-items-center">
          <div class="col-sm-3 mb-3 mb-sm-0">
            <router-link class="font-weight-semibold" :to="$investment.getRoute(investment)">
              {{ investment.title }}
            </router-link>
          </div>
          <div class="col-sm-5">
            <div class="row">
              <div class="col-6 text-sm-right">
                <div class="label">
                  Interest Rate
                </div>
                <div class="font-weight-semibold">
                  {{ investment.funding.interestRate }}% p.a.
                </div>
              </div>
              <div class="col-6 text-sm-right">
                <div class="label">
                  Share Price
                </div>
                <div class="font-weight-semibold">
                  {{ $formatting.toCurrency(investment.costPerShare) }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4 mt-3 mt-sm-0 text-center text-sm-right">
            <base-button secondary :to="$investment.getRoute(investment)">
              Fund Loan
            </base-button>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <p>
        There are no co-funding opportunities available.
      </p>
    </template>
  </base-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'InvestmentCoFundingOpportunities',

  data: () => ({
    investments: [],
    pending: true
  }),

  async created () {
    const investments = await this.getInvestments({
      investmentType: 'CoFundingLoan'
    })

    this.investments = investments
    this.pending = false
  },

  methods: {
    ...mapActions({
      getInvestments: 'core/investments/opportunities'
    })
  }
}
</script>
